<template>
  <FormModal
    v-if="data"
    title="Add Site Custom Script"
    method="POST"
    :endpoint="`partners/${partner_id}/sites/${site_id}/custom-scripts`"
    :data="data"
    v-bind="$attrs"
    size="wide"
    @success="success"
  >
    <InputGroup label="Target" name="target" description="Which script should this custom script be included with.">
      <Select v-model="data.target" endpoint="options/script-names" prepend-option="All Scripts" disabled />
    </InputGroup>

    <InputGroup label="Description" name="description" description="Describe what this custom script does/is for.">
      <TextInput v-model="data.description" />
    </InputGroup>

    <InputGroup
      label="Custom Script"
      name="content"
      description="The custom script code with no wrapping functions. Example: window.alert('Hello, world!');"
    >
      <TextInput v-model="data.content" textarea :rows="20" />
      <Button prepend-icon="magic" class="mt-2" @click="checkScript()">Check script</Button>
    </InputGroup>

    <InputGroup label="Enabled" name="enabled">
      <ToggleSwitch v-model="data.enabled" label="Enable this custom script" />
    </InputGroup>
  </FormModal>
</template>

<script>
import CheckScriptStyleMixin from "./CheckScriptStyleMixin"

export default {
  props: {
    partner_id: {
      type: Number,
      required: true
    },
    site_id: {
      type: Number,
      required: true
    }
  },
  mixins: [CheckScriptStyleMixin],
  data: () => ({
    data: {
      target: 'copilot',
      description: "",
      content: "",
      enabled: true
    }
  }),
  methods: {
    success(result) {
      this.$notification.success(`Custom script successfully added.`)
      this.$emit("close", result)
    }
  }
}
</script>
